export default "__VITE_ASSET__00749b23__"